// extracted by mini-css-extract-plugin
export default {"main":"cardstyle1_main__-LqKh","w80":"cardstyle1_w80__5FqQ7","img":"cardstyle1_img__+nWro","title":"cardstyle1_title__+JY5x","pin":"cardstyle1_pin__eXaS-"};